import * as React from 'react'
import {
	LayoutDashboard,
	CalendarDays,
	CalendarClock,
	CalendarCheck,
	ListTodo,
	User,
	CircleCheck,
	Send,
	FolderKanban,
	Timer,
	FileSignature,
	Book,
	ScrollText,
	FileText,
	Receipt,
	Inbox,
	Megaphone,
	MessageSquare,
	Landmark,
	Wallet,
	ArrowRightLeft,
	Banknote,
	Package,
	ChartNoAxesCombined,
	Zap,
	CreditCard,
	Settings,
	Users,
	FormInput,
	Folder,
	Calculator,
	Copy,
} from 'lucide-react'
import { IconTypes } from '../Icons/Icon'

const SHORTCUT_ICONS: Partial<Record<IconTypes, React.ComponentType<{ className?: string }>>> = {
	'dashboard-navigation': LayoutDashboard,
	'calendar-day': CalendarDays,
	'calendar-clock': CalendarClock,
	'calendar-check': CalendarCheck,
	'tasks': ListTodo,
	'user': User,
	'check-circle': CircleCheck,
	'paper-plane': Send,
	'project-navigation': FolderKanban,
	'stopwatch': Timer,
	'proposal': FileSignature,
	'book': Book,
	'file-contract': ScrollText,
	'invoice': FileText,
	'expense': Receipt,
	'receipt': Receipt,
	'inbox': Inbox,
	'bullhorn': Megaphone,
	'messenger-conversations-active': MessageSquare,
	'bank': Landmark,
	'sack-dollar': Wallet,
	'arrow-right-arrow-left': ArrowRightLeft,
	'money-bill': Banknote,
	'product-navigation': Package,
	'reporting-navigation': ChartNoAxesCombined,
	'bolt': Zap,
	'creditcard': CreditCard,
	'setting': Settings,
	'team': Users,
	'input-pipe': FormInput,
	'folder': Folder,
	'accountant': Calculator,
	'copy': Copy,
}

export default SHORTCUT_ICONS
